<template lang="pug">
    div
        regular-button(@click="open" :value="FORMS_LABELS.add_new_user")
        modal(name="add-user" height="auto" :width="760" :adaptive="true" :scrollable="true" classes="form-modal")
            .p-4.bg-gray-100.flex.flex-col.gap-4(:key="formKey")
                    .grid.grid-cols-3.gap-4.min-w-0
                        text-input(:label="FORMS_LABELS.user_name" @value="firstname = $event" :value="firstname")
                        text-input(:label="FORMS_LABELS.user_lastname" @value="lastname = $event" :value="lastname")
                        text-input(:label="FORMS_LABELS.user_patronymic" @value="patronymic = $event" :value="patronymic")

                    .grid.grid-cols-2.gap-4.min-w-0
                        text-input(:label="FORMS_LABELS.email" @value="email = $event" :value="email")
                        text-input(:label="FORMS_LABELS.phone" @value="phone = $event" :value="phone" v-mask="'+#(###) ###-##-##'")

                    .grid.grid-cols-2.gap-4.min-w-0.items-end
                        select-option(:label="FORMS_LABELS.user_role" name="role" :options="onRoleCollection()" @value="onRole")
                        select-option(
                            v-if="isStationRole"
                            :label="FORMS_LABELS.user_group"
                            name="group"
                            :options="USER_GROUPS"
                            @value="onGroup"
                        )
                        .relative.min-w-0(:class="isStationRole ? 'col-span-2' : ''")
                            text-input.block(:label="FORMS_LABELS.password" @value="password = $event" :value="password")
                            inline-svg.absolute.bottom-3.right-10.cursor-pointer(
                                :src="ICONS.loop"
                                @click="onGeneratePassword"
                            )
                            inline-svg.absolute.bottom-3.right-3.cursor-pointer(
                                :src="ICONS.clipboard"
                                :title="BUTTONS_VALUES.copy_to_clipboard"
                                @click="copyToClipboard({ value: password })"
                            )

                    drag-n-drop-files(@files="photo = $event" label="Добавить фото")

                    div
                        checkbox.mb-4(@checked="onStatus" label="Заблокировать" :checked="status_checked")
                        checkbox(@checked="onSendEmail" :label="`Отправить на email ${email}`" :checked="send_email_checked")

                    .flex.items-center.gap-3
                        regular-button.w-32(:value="BUTTONS_VALUES.save" :loading="isSaving" @click="onSave")
                        regular-button.w-32(:value="BUTTONS_VALUES.cancel" color="gray" :isActive="!isSaving" @click="close")
</template>

<script>
//Components
import TextInput from '@/components/common/forms/text-input';
import Select from '@/components/common/forms/select-option';
import Checkbox from '@/components/common/forms/checkbox';
import RegularButton from '@/components/common/buttons/regular-button';
import DragNDropFiles from '@/components/common/forms/drag-n-drop-files';
//Config
import { FORMS_LABELS, BUTTONS_VALUES } from '@/configs/names';
import { ICONS } from '@/configs/icons';
import { USER_ROLES } from '@/configs/user-roles';
import { USER_GROUPS } from '@/configs/user-groups';
//Store
import { UsersNameSpace, UsersActionTypes } from '@/store/users/types';
import { AuthorizationNameSpace, AuthorizationGetterTypes } from '@/store/authorization/types';
//Helpers
import { generatePassword } from '@/helpers/password-generator';
import { notifyError } from '../../../helpers/notifications';
import { copyToClipboard } from '@/helpers/copy-to-clipboard.js';
//Mixins
import { _onFileUpload_ } from '@/mixins/files';
import { _openModal_, _closeModal_ } from '@/mixins/modals';

export default {
    name: "AddUserComponent",
    mixins: [_onFileUpload_, _openModal_, _closeModal_],
    components: {
        'text-input': TextInput,
        'regular-button': RegularButton,
        'checkbox': Checkbox,
        'select-option': Select,
        'drag-n-drop-files': DragNDropFiles,
    },
    data() {
        return {
            firstname: '',
            lastname: '',
            patronymic: '',
            email: '',
            phone: '',
            password: '',
            photo: [],
            status_checked: false,
            send_email_checked: true,
            status: 1,
            send_email: 1,
            role: null,
            group: null,
            isSaving: false,
            formKey: 0,
        }
    },
    computed: {
        FORMS_LABELS() {
            return FORMS_LABELS
        },
        BUTTONS_VALUES() {
            return BUTTONS_VALUES
        },
        ICONS() {
            return ICONS
        },
        USER_ROLES() {
            const result = [{ 
                    value: '',
                    selected: true, 
                    disabled: true, 
                    hidden: true,
                }
            ]
            return [...result, ...USER_ROLES]
        },
        USER_GROUPS() {
            const result = [{ 
                    value: '',
                    selected: true, 
                    disabled: true, 
                    hidden: true,
                }
            ]
            const groups = USER_GROUPS.filter(group => group.value !== 1)
            return [...result, ...groups]
        },
        isStationRole() {
            return this.role === 3
        },
        user_role() {
            return this.$store.getters[`${AuthorizationNameSpace}/${AuthorizationGetterTypes.GetRole}`]
        },
    },
    mounted() {
        this.onGeneratePassword()
    },
    methods: {
        open() {
            this.resetForm()
            this._openModal_({ name: 'add-user' })
        },
        close() {
            if (this.isSaving) {
                return
            }
            this._closeModal_({ name: 'add-user' })
        },
        resetForm() {
            this.firstname = ''
            this.lastname = ''
            this.patronymic = ''
            this.email = ''
            this.phone = ''
            this.photo = []
            this.status_checked = false
            this.send_email_checked = true
            this.status = 1
            this.send_email = 1
            this.role = null
            this.group = null
            this.formKey += 1
            this.onGeneratePassword()
        },
        generatePassword() {
            return generatePassword()
        },
        copyToClipboard({value}) {
            return copyToClipboard({value})
        },
        async onSave() {
            if (this.isSaving) {
                return
            }
            if (!this.role) {
                notifyError({ title: 'Выберите роль' })
                return
            }
            if (this.isStationRole && !this.group) {
                notifyError({ title: 'Для модератора выберите станцию' })
                return
            }
            this.isSaving = true
            try {
                if (this.photo.length) await this._onFileUpload_({ field: 'photo' })
                const form = { ...this.$data }
                delete form.isSaving
                const result = await this.$store.dispatch(`${UsersNameSpace}/${UsersActionTypes.AddUser}`, { data: {
                            ...form,
                            status: this.status_checked ? 0 : 1,
                            send_email: this.send_email_checked ? 1 : 0,
                            photo: this.photo.length ? this._loadedFile_._id : undefined,
                            group: this.isStationRole ? this.group : 1,
                            phone: this.phone.replace(/\D+/g, ''),
                        }
                    }
                )
                if (result && !result.error_message) {
                    this.$emit('created', result)
                    this._closeModal_({ name: 'add-user' })
                    this.resetForm()
                }
            } catch (error) {
                notifyError({ title: 'Не удалось создать пользователя' })
            } finally {
                this.isSaving = false
            }
        },
        onGeneratePassword() {
            const result = this.generatePassword()
            this.password = result
        },
        onStatus(value) {
            this.status_checked = value
            this.status = value ? 0 : 1
        },
        onSendEmail(value) {
            this.send_email_checked = value
            this.send_email = value ? 1 : 0
        },
        onRole(value) {
            this.role = this.USER_ROLES.find(r => r.name === value).value
            if (this.role === 3 && this.group === 1) {
                this.group = null
            }
        },
        onGroup(value) {
            this.group = this.USER_GROUPS.find(r => r.name === value).value
        },
        onRoleCollection() {
            //Убираем superadmin для остальных ролей
            let result = []
            
            if (this.user_role !== 1) {
                result = this.USER_ROLES.filter(r => r.value !== 1)
            } else {
                result = this.USER_ROLES
            }
            return result
        }
    }
}
</script>